import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import {
  getWeeklyreport,
  saveWeeklyNotes,
  sendWeeklyReport,
  setFeedbackStatus,
  type weeklyReportResponse,
  type WeekSelection,
} from 'services/api/weekly-report';

export function weeklyReportQueryKey(selection: WeekSelection) {
  return ['weekly-report', selection?.isoYear ?? null, selection?.isoWeek ?? null] as const;
}

export function useWeeklyReport(selection: WeekSelection) {
  return useQuery<weeklyReportResponse>({
    queryKey: weeklyReportQueryKey(selection),
    queryFn: () => getWeeklyreport(selection),
    retry: false,
    placeholderData: keepPreviousData,
  });
}

export function useSaveWeeklyNotes(selection: WeekSelection) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveWeeklyNotes,
    onSuccess: () => qc.invalidateQueries({ queryKey: weeklyReportQueryKey(selection) }),
  });
}

export function useSendWeeklyReport() {
  return useMutation({ mutationFn: sendWeeklyReport });
}

export function useSetFeedbackStatus(selection: WeekSelection) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: setFeedbackStatus,
    onSuccess: () => qc.invalidateQueries({ queryKey: weeklyReportQueryKey(selection) }),
  });
}
